import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="London" />
        <footer>
          This app was coded by{" "}
          <a
            href="https://www.shecodes.io/graduates/147891-emily-huggins"
            target="_blank"
            rel="noopener noreferrer"
          >
            Emily Huggins
          </a>{" "}
          and is{" "}
          <a
            href="https://github.com/emilyrh/react-weather"
            target="_blank"
            rel="noopener noreferrer"
          >
            open-sourced on GitHub
          </a>{" "}
          and{" "}
          <a
            href="https://illustrious-cupcake-077d45.netlify.app"
            target="_blank"
            rel="noopener noreferrer"
          >
            hosted on Netlify
          </a>
        </footer>
      </div>
    </div>
  );
}
